// Icons referenced by name (string) from src/data/** and a few components.
// Resolving names through this explicit map — instead of `import * as Icons from "lucide-react"` —
// lets webpack tree-shake lucide: a single namespace import marks all ~1,650 icons as used
// app-wide and ships them (≈130 KB gzip) to every page, including the home page.
// Referencing a new icon name in data? Add it here, or ICONS[name] is undefined and the icon is skipped.
import {
  Accessibility as I_Accessibility,
  Activity as I_Activity,
  AppWindow as I_AppWindow,
  Apple as I_Apple,
  ArrowRightLeft as I_ArrowRightLeft,
  ArrowUpCircle as I_ArrowUpCircle,
  Atom as I_Atom,
  Award as I_Award,
  BadgeCheck as I_BadgeCheck,
  BarChart2 as I_BarChart2,
  BarChart3 as I_BarChart3,
  BedDouble as I_BedDouble,
  Beer as I_Beer,
  Bell as I_Bell,
  Blend as I_Blend,
  Blocks as I_Blocks,
  BookOpen as I_BookOpen,
  Bot as I_Bot,
  Boxes as I_Boxes,
  Braces as I_Braces,
  Brain as I_Brain,
  BrainCircuit as I_BrainCircuit,
  BrainCog as I_BrainCog,
  Briefcase as I_Briefcase,
  BriefcaseBusiness as I_BriefcaseBusiness,
  Bug as I_Bug,
  BugPlay as I_BugPlay,
  Building2 as I_Building2,
  Cable as I_Cable,
  Calculator as I_Calculator,
  CalendarCheck as I_CalendarCheck,
  CalendarClock as I_CalendarClock,
  CalendarDays as I_CalendarDays,
  CalendarRange as I_CalendarRange,
  Camera as I_Camera,
  Car as I_Car,
  ChartColumnIncreasing as I_ChartColumnIncreasing,
  ChartLine as I_ChartLine,
  ChartNoAxesCombined as I_ChartNoAxesCombined,
  CheckCircle as I_CheckCircle,
  CheckCircle2 as I_CheckCircle2,
  ChefHat as I_ChefHat,
  CircleDollarSign as I_CircleDollarSign,
  Clapperboard as I_Clapperboard,
  ClipboardCheck as I_ClipboardCheck,
  ClipboardList as I_ClipboardList,
  Clock as I_Clock,
  ClockAlert as I_ClockAlert,
  ClockFading as I_ClockFading,
  Cloud as I_Cloud,
  CloudAlert as I_CloudAlert,
  CloudCheck as I_CloudCheck,
  CloudCog as I_CloudCog,
  CloudDownload as I_CloudDownload,
  CloudSync as I_CloudSync,
  Code as I_Code,
  Code2 as I_Code2,
  CodeXml as I_CodeXml,
  Coffee as I_Coffee,
  Cog as I_Cog,
  Compass as I_Compass,
  Component as I_Component,
  Construction as I_Construction,
  Cpu as I_Cpu,
  CreditCard as I_CreditCard,
  Crown as I_Crown,
  Database as I_Database,
  DatabaseZap as I_DatabaseZap,
  DollarSign as I_DollarSign,
  Download as I_Download,
  Eye as I_Eye,
  Factory as I_Factory,
  FileCheck as I_FileCheck,
  FileJson as I_FileJson,
  FileSearch as I_FileSearch,
  FileStack as I_FileStack,
  FileText as I_FileText,
  FlaskConical as I_FlaskConical,
  FolderOpen as I_FolderOpen,
  Gauge as I_Gauge,
  Gem as I_Gem,
  Gift as I_Gift,
  GitBranch as I_GitBranch,
  GitBranchPlus as I_GitBranchPlus,
  GitCompare as I_GitCompare,
  GitMerge as I_GitMerge,
  Globe as I_Globe,
  GraduationCap as I_GraduationCap,
  Hammer as I_Hammer,
  Handshake as I_Handshake,
  HardDrive as I_HardDrive,
  HardHat as I_HardHat,
  Headphones as I_Headphones,
  Headset as I_Headset,
  Heart as I_Heart,
  HeartHandshake as I_HeartHandshake,
  HeartPulse as I_HeartPulse,
  HelpCircle as I_HelpCircle,
  Hexagon as I_Hexagon,
  History as I_History,
  Home as I_Home,
  House as I_House,
  Import as I_Import,
  Infinity as I_Infinity,
  Landmark as I_Landmark,
  Languages as I_Languages,
  Laptop as I_Laptop,
  Layers as I_Layers,
  Layers2 as I_Layers2,
  LayoutDashboard as I_LayoutDashboard,
  LayoutGrid as I_LayoutGrid,
  LayoutTemplate as I_LayoutTemplate,
  LifeBuoy as I_LifeBuoy,
  Lightbulb as I_Lightbulb,
  LineChart as I_LineChart,
  ListChecks as I_ListChecks,
  Lock as I_Lock,
  Map as I_Map,
  MapPin as I_MapPin,
  MapPinHouse as I_MapPinHouse,
  MessageCircle as I_MessageCircle,
  MessageSquare as I_MessageSquare,
  MessageSquareCode as I_MessageSquareCode,
  MessageSquareDot as I_MessageSquareDot,
  MessageSquareText as I_MessageSquareText,
  MessagesSquare as I_MessagesSquare,
  Monitor as I_Monitor,
  MonitorCheck as I_MonitorCheck,
  MonitorCloud as I_MonitorCloud,
  MonitorCog as I_MonitorCog,
  MonitorPlay as I_MonitorPlay,
  MonitorSmartphone as I_MonitorSmartphone,
  MonitorUp as I_MonitorUp,
  MousePointerClick as I_MousePointerClick,
  Navigation as I_Navigation,
  Network as I_Network,
  Newspaper as I_Newspaper,
  Package as I_Package,
  Palette as I_Palette,
  PanelsTopLeft as I_PanelsTopLeft,
  PenTool as I_PenTool,
  PencilRuler as I_PencilRuler,
  Pill as I_Pill,
  Plane as I_Plane,
  Plug as I_Plug,
  PlugZap as I_PlugZap,
  Puzzle as I_Puzzle,
  Radar as I_Radar,
  Radio as I_Radio,
  RadioTower as I_RadioTower,
  Receipt as I_Receipt,
  Recycle as I_Recycle,
  RefreshCcw as I_RefreshCcw,
  RefreshCw as I_RefreshCw,
  Repeat as I_Repeat,
  Rocket as I_Rocket,
  Route as I_Route,
  Scaling as I_Scaling,
  ScanSearch as I_ScanSearch,
  ScreenShare as I_ScreenShare,
  ScrollText as I_ScrollText,
  Search as I_Search,
  SearchCheck as I_SearchCheck,
  Server as I_Server,
  ServerCrash as I_ServerCrash,
  Settings as I_Settings,
  Settings2 as I_Settings2,
  Shield as I_Shield,
  ShieldAlert as I_ShieldAlert,
  ShieldCheck as I_ShieldCheck,
  ShieldCog as I_ShieldCog,
  ShieldPlus as I_ShieldPlus,
  ShieldUser as I_ShieldUser,
  Shirt as I_Shirt,
  ShoppingBag as I_ShoppingBag,
  ShoppingBasket as I_ShoppingBasket,
  ShoppingCart as I_ShoppingCart,
  SlidersHorizontal as I_SlidersHorizontal,
  Smartphone as I_Smartphone,
  Sparkles as I_Sparkles,
  Sprout as I_Sprout,
  Square as I_Square,
  SquareTerminal as I_SquareTerminal,
  Stethoscope as I_Stethoscope,
  Store as I_Store,
  Table as I_Table,
  Table2 as I_Table2,
  TabletSmartphone as I_TabletSmartphone,
  Target as I_Target,
  ThumbsUp as I_ThumbsUp,
  Ticket as I_Ticket,
  TrendingDown as I_TrendingDown,
  TrendingUp as I_TrendingUp,
  Triangle as I_Triangle,
  Truck as I_Truck,
  Tv as I_Tv,
  Umbrella as I_Umbrella,
  UserCheck as I_UserCheck,
  UserCog as I_UserCog,
  UserLock as I_UserLock,
  UserPen as I_UserPen,
  UserRound as I_UserRound,
  Users as I_Users,
  UsersRound as I_UsersRound,
  UtensilsCrossed as I_UtensilsCrossed,
  Video as I_Video,
  Wallet as I_Wallet,
  WalletCards as I_WalletCards,
  Warehouse as I_Warehouse,
  Waypoints as I_Waypoints,
  Webhook as I_Webhook,
  Wine as I_Wine,
  Workflow as I_Workflow,
  Wrench as I_Wrench,
  Zap as I_Zap,
} from "lucide-react";

export const ICONS = {
  Accessibility: I_Accessibility,
  Activity: I_Activity,
  AppWindow: I_AppWindow,
  Apple: I_Apple,
  ArrowRightLeft: I_ArrowRightLeft,
  ArrowUpCircle: I_ArrowUpCircle,
  Atom: I_Atom,
  Award: I_Award,
  BadgeCheck: I_BadgeCheck,
  BarChart2: I_BarChart2,
  BarChart3: I_BarChart3,
  BedDouble: I_BedDouble,
  Beer: I_Beer,
  Bell: I_Bell,
  Blend: I_Blend,
  Blocks: I_Blocks,
  BookOpen: I_BookOpen,
  Bot: I_Bot,
  Boxes: I_Boxes,
  Braces: I_Braces,
  Brain: I_Brain,
  BrainCircuit: I_BrainCircuit,
  BrainCog: I_BrainCog,
  Briefcase: I_Briefcase,
  BriefcaseBusiness: I_BriefcaseBusiness,
  Bug: I_Bug,
  BugPlay: I_BugPlay,
  Building2: I_Building2,
  Cable: I_Cable,
  Calculator: I_Calculator,
  CalendarCheck: I_CalendarCheck,
  CalendarClock: I_CalendarClock,
  CalendarDays: I_CalendarDays,
  CalendarRange: I_CalendarRange,
  Camera: I_Camera,
  Car: I_Car,
  ChartColumnIncreasing: I_ChartColumnIncreasing,
  ChartLine: I_ChartLine,
  ChartNoAxesCombined: I_ChartNoAxesCombined,
  CheckCircle: I_CheckCircle,
  CheckCircle2: I_CheckCircle2,
  ChefHat: I_ChefHat,
  CircleDollarSign: I_CircleDollarSign,
  Clapperboard: I_Clapperboard,
  ClipboardCheck: I_ClipboardCheck,
  ClipboardList: I_ClipboardList,
  Clock: I_Clock,
  ClockAlert: I_ClockAlert,
  ClockFading: I_ClockFading,
  Cloud: I_Cloud,
  CloudAlert: I_CloudAlert,
  CloudCheck: I_CloudCheck,
  CloudCog: I_CloudCog,
  CloudDownload: I_CloudDownload,
  CloudSync: I_CloudSync,
  Code: I_Code,
  Code2: I_Code2,
  CodeXml: I_CodeXml,
  Coffee: I_Coffee,
  Cog: I_Cog,
  Compass: I_Compass,
  Component: I_Component,
  Construction: I_Construction,
  Cpu: I_Cpu,
  CreditCard: I_CreditCard,
  Crown: I_Crown,
  Database: I_Database,
  DatabaseZap: I_DatabaseZap,
  DollarSign: I_DollarSign,
  Download: I_Download,
  Eye: I_Eye,
  Factory: I_Factory,
  FileCheck: I_FileCheck,
  FileJson: I_FileJson,
  FileSearch: I_FileSearch,
  FileStack: I_FileStack,
  FileText: I_FileText,
  FlaskConical: I_FlaskConical,
  FolderOpen: I_FolderOpen,
  Gauge: I_Gauge,
  Gem: I_Gem,
  Gift: I_Gift,
  GitBranch: I_GitBranch,
  GitBranchPlus: I_GitBranchPlus,
  GitCompare: I_GitCompare,
  GitMerge: I_GitMerge,
  Globe: I_Globe,
  GraduationCap: I_GraduationCap,
  Hammer: I_Hammer,
  Handshake: I_Handshake,
  HardDrive: I_HardDrive,
  HardHat: I_HardHat,
  Headphones: I_Headphones,
  Headset: I_Headset,
  Heart: I_Heart,
  HeartHandshake: I_HeartHandshake,
  HeartPulse: I_HeartPulse,
  HelpCircle: I_HelpCircle,
  Hexagon: I_Hexagon,
  History: I_History,
  Home: I_Home,
  House: I_House,
  Import: I_Import,
  Infinity: I_Infinity,
  Landmark: I_Landmark,
  Languages: I_Languages,
  Laptop: I_Laptop,
  Layers: I_Layers,
  Layers2: I_Layers2,
  LayoutDashboard: I_LayoutDashboard,
  LayoutGrid: I_LayoutGrid,
  LayoutTemplate: I_LayoutTemplate,
  LifeBuoy: I_LifeBuoy,
  Lightbulb: I_Lightbulb,
  LineChart: I_LineChart,
  ListChecks: I_ListChecks,
  Lock: I_Lock,
  Map: I_Map,
  MapPin: I_MapPin,
  MapPinHouse: I_MapPinHouse,
  MessageCircle: I_MessageCircle,
  MessageSquare: I_MessageSquare,
  MessageSquareCode: I_MessageSquareCode,
  MessageSquareDot: I_MessageSquareDot,
  MessageSquareText: I_MessageSquareText,
  MessagesSquare: I_MessagesSquare,
  Monitor: I_Monitor,
  MonitorCheck: I_MonitorCheck,
  MonitorCloud: I_MonitorCloud,
  MonitorCog: I_MonitorCog,
  MonitorPlay: I_MonitorPlay,
  MonitorSmartphone: I_MonitorSmartphone,
  MonitorUp: I_MonitorUp,
  MousePointerClick: I_MousePointerClick,
  Navigation: I_Navigation,
  Network: I_Network,
  Newspaper: I_Newspaper,
  Package: I_Package,
  Palette: I_Palette,
  PanelsTopLeft: I_PanelsTopLeft,
  PenTool: I_PenTool,
  PencilRuler: I_PencilRuler,
  Pill: I_Pill,
  Plane: I_Plane,
  Plug: I_Plug,
  PlugZap: I_PlugZap,
  Puzzle: I_Puzzle,
  Radar: I_Radar,
  Radio: I_Radio,
  RadioTower: I_RadioTower,
  Receipt: I_Receipt,
  Recycle: I_Recycle,
  RefreshCcw: I_RefreshCcw,
  RefreshCw: I_RefreshCw,
  Repeat: I_Repeat,
  Rocket: I_Rocket,
  Route: I_Route,
  Scaling: I_Scaling,
  ScanSearch: I_ScanSearch,
  ScreenShare: I_ScreenShare,
  ScrollText: I_ScrollText,
  Search: I_Search,
  SearchCheck: I_SearchCheck,
  Server: I_Server,
  ServerCrash: I_ServerCrash,
  Settings: I_Settings,
  Settings2: I_Settings2,
  Shield: I_Shield,
  ShieldAlert: I_ShieldAlert,
  ShieldCheck: I_ShieldCheck,
  ShieldCog: I_ShieldCog,
  ShieldPlus: I_ShieldPlus,
  ShieldUser: I_ShieldUser,
  Shirt: I_Shirt,
  ShoppingBag: I_ShoppingBag,
  ShoppingBasket: I_ShoppingBasket,
  ShoppingCart: I_ShoppingCart,
  SlidersHorizontal: I_SlidersHorizontal,
  Smartphone: I_Smartphone,
  Sparkles: I_Sparkles,
  Sprout: I_Sprout,
  Square: I_Square,
  SquareTerminal: I_SquareTerminal,
  Stethoscope: I_Stethoscope,
  Store: I_Store,
  Table: I_Table,
  Table2: I_Table2,
  TabletSmartphone: I_TabletSmartphone,
  Target: I_Target,
  ThumbsUp: I_ThumbsUp,
  Ticket: I_Ticket,
  TrendingDown: I_TrendingDown,
  TrendingUp: I_TrendingUp,
  Triangle: I_Triangle,
  Truck: I_Truck,
  Tv: I_Tv,
  Umbrella: I_Umbrella,
  UserCheck: I_UserCheck,
  UserCog: I_UserCog,
  UserLock: I_UserLock,
  UserPen: I_UserPen,
  UserRound: I_UserRound,
  Users: I_Users,
  UsersRound: I_UsersRound,
  UtensilsCrossed: I_UtensilsCrossed,
  Video: I_Video,
  Wallet: I_Wallet,
  WalletCards: I_WalletCards,
  Warehouse: I_Warehouse,
  Waypoints: I_Waypoints,
  Webhook: I_Webhook,
  Wine: I_Wine,
  Workflow: I_Workflow,
  Wrench: I_Wrench,
  Zap: I_Zap,
};

